export default "__VITE_ASSET__BqPA1tfo__"